import { render, staticRenderFns } from "./JdmsSpecification.vue?vue&type=template&id=33766354&scoped=true"
import script from "./JdmsSpecification.vue?vue&type=script&lang=js"
export * from "./JdmsSpecification.vue?vue&type=script&lang=js"
import style0 from "./JdmsSpecification.vue?vue&type=style&index=0&id=33766354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33766354",
  null
  
)

export default component.exports